import React from 'react';

// Components
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';

const NoSourceLocationsAvailable = () => (
  <Stack direction="row" justifyContent="center" sx={{ width: 1 }}>
    <Box
      bgcolor="graphic.lighter"
      borderRadius="4px"
      color="text.secondary"
      fontFamily="Gothic A1"
      fontWeight={300}
      ml={{ md: 1 }}
      mt={{ md: 1 }}
      padding={3}
      textAlign="center"
      width="100%"
    >
      <BlockRoundedIcon
        sx={{
          height: 38,
          mb: 1,
          width: 38,
        }}
      />
      <Box component="p" fontSize={20} my={1}>
        No available Source Locations.
      </Box>
      <Box component="p" fontSize={16} mb={0.5} mt={0}>
        Try adjusting your search or filter options.
      </Box>
    </Box>
  </Stack>
);

export default NoSourceLocationsAvailable;
